import classNames from 'classnames'
import { observer } from 'mobx-react'
import './index.scss'
const ServiceItem = observer(({ isDark, dt }: { isDark: boolean; dt: any }) => {
  return (
    <section className={classNames('service-item', isDark && 'dark')}>
      <div className="service-item__top">
        <img src={dt.icon} /> {dt.title}
      </div>
      {dt.text.length ? (
        <div className="service-item__text">{dt.text}</div>
      ) : (
        <></>
      )}
    </section>
  )
})

export default ServiceItem
